export const environment = {
  type: 'PROD',
  production: true,
};
